<template>
  <div class="mod-config">
    <div class="strtop" style="text-align: right;line-height: 50px;">
      <el-dropdown placement="bottom" trigger="click" style="margin-left: 10px;">
        <img src="../../../assets/icons/catalog.png" alt="" width="30" height="30" style="cursor: pointer;">
        <el-dropdown-menu slot="dropdown"
          style="margin-top:4px;width: 150px;text-align: center;box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.4)">
          <el-dropdown-item v-if="isAuth('alarmBalance:update') ">
            <p @click="dialogFormVisible = true">余额告警设置</p>
          </el-dropdown-item>
          <el-dropdown-item v-if="isAuth('recharge:record')">
            <router-link to="/indexhome/management/alarmBalance" replace style="color: #606266;text-decoration: auto;">
              <p>充值记录</p>
            </router-link>
          </el-dropdown-item>
          <el-dropdown-item v-if="isAuth('alarmPush:record')">
            <router-link to="/indexhome/management/record" replace style="color: #606266;text-decoration: auto;">
              <p>推送记录</p>
            </router-link>
          </el-dropdown-item>
          <el-dropdown-item v-if="isAuth('recharge:alarmNum') ">
            <p @click="rechargeVisible = true">充值</p>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <div class="boxindex">
      <!-- 短信 -->
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <i class="list_i"></i>
          <span>短信推送</span>
          <span>余额告警数 <i>{{ smsThreshold }}</i></span>
        </div>
        <el-table :data="smsBalanceList" height="350" border style="width: 100%;">
          <el-table-column prop="smsBalance" label="可用余额" align="center">
          </el-table-column>
          <el-table-column prop="smsEndTime" label="到期时间" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" width="100" v-if="isAuth('alarmBalance:allocation') ">
            <template slot-scope="scope">
              <el-button type="text" style="color: #000;font-size: 24px;" @click="operate(scope.row, '0')">
                <img src="../../../assets/img/branches.png" alt="" style="margin-bottom: 7px;" width="18" height="18">
              </el-button>
              <!-- <el-button type="text" style="color: #000;font-size: 24px;" @click="operate(scope.row, '0')"><i
                  class="el-icon-link"></i></el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <!-- 邮件 -->
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <i class="list_i"></i>
          <span>邮件推送</span>
          <span>余额告警数 <i>{{ emailThreshold }}</i></span>
        </div>
        <el-table :data="emailBalanceList" height="350" border style="width: 100%;">
          <el-table-column prop="emailBalance" label="可用余额" align="center">
          </el-table-column>
          <el-table-column prop="emailEndTime" label="到期时间" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" width="100" v-if="isAuth('alarmBalance:allocation')">
            <template slot-scope="scope">
              <el-button type="text" style="color: #000;font-size: 24px;" @click="operate(scope.row, '2')">
                <img src="../../../assets/img/branches.png" alt="" style="margin-bottom: 7px;" width="18" height="18">
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <!-- 语音 -->
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <i class="list_i"></i>
          <span>语音推送</span>
          <span>余额告警数 <i>{{ voiceThreshold }}</i></span>
        </div>
        <el-table :data="voiceBalanceList" height="350" border style="width: 100%;">
          <el-table-column prop="voiceBalance" label="可用余额" align="center">
          </el-table-column>
          <el-table-column prop="voiceEndTime" label="到期时间" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" width="100" v-if="isAuth('alarmBalance:allocation') ">
            <template slot-scope="scope">
              <el-button type="text" style="color: #000;font-size: 24px;" @click="operate(scope.row, '1')">
                <img src="../../../assets/img/branches.png" alt="" style="margin-bottom: 7px;" width="18" height="18">
              </el-button>
              <!-- <el-button type="text" style="color: #000;font-size: 24px;" @click="operate(scope.row, '1')"><i
                  class="el-icon-link"></i></el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </el-card>

    </div>

    <!-- 余额告警设置  -->
    <el-dialog title="余额告警设置" :visible.sync="dialogFormVisible" :modal-append-to-body="false" :show-close="true"
      :close-on-click-modal="false" :append-to-body="true" width="400px" class="tkye">
      <el-form :model="form" style="margin-top: 10px;">
        <el-form-item label="短信余额告警数" :label-width="formLabelWidth">
          <el-input v-model="form.smsThreshold" :min="0" oninput="if(value<0)value=0"
            placeholder="短信余额达到该数时将会告警"></el-input>
        </el-form-item>
        <el-form-item label="邮件余额告警数" :label-width="formLabelWidth">
          <el-input v-model="form.emailThreshold" :min="0" oninput="if(value<0)value=0"
            placeholder="邮件余额达到该数时将会告警"></el-input>
        </el-form-item>
        <el-form-item label="语音余额告警数" :label-width="formLabelWidth">
          <el-input v-model="form.voiceThreshold" :min="0" oninput="if(value<0)value=0"
            placeholder="语音余额达到该数时将会告警"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="alarmBalanceUpdate">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 余额分配 -->
    <el-dialog title="余额分配" :visible.sync="operateVisible" :modal-append-to-body="false" :show-close="true"
      :close-on-click-modal="false" :append-to-body="true" width="400px" class="tk">
      <el-form :model="form_operate" style="margin-top: 10px;">
        <el-form-item label="分配种类：">
          <span>{{ form_operate.type }}</span>
        </el-form-item>
        <el-form-item label="可用条数：">
          <span>{{ form_operate.balance }}</span>
        </el-form-item>
        <el-form-item label="到期时间：">
          <span>{{ form_operate.time }}</span>
        </el-form-item>
        <hr>
        <el-form-item label="分配数量：" label-width="80px">
          <el-input v-model="form_operate.totalCount" autocomplete="off" placeholder="请输入分配数量"></el-input>
        </el-form-item>
        <el-form-item label="分配账号：" label-width="80px">
          <el-select v-model="form_operate.userList" multiple filterable allow-create default-first-option
            placeholder="请选择分配账号" style="width: 100%;" @change="handleChange" value-key="id">
            <el-option v-for="item in options" :key="item.id" :label="item.username" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="operateVisible = false">取 消</el-button>
        <el-button type="primary" @click="allocation">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 充值 -->
    <el-dialog title="充值" :visible.sync="rechargeVisible" :modal-append-to-body="false" :show-close="true"
      :close-on-click-modal="false" :append-to-body="true" width="400px" class="tkye">
      <el-form :model="form_operate" style="margin-top: 10px;">
        <el-form-item label="充值密码">
          <el-input v-model="form_operate.password" :min="0" oninput="if(value<0)value=0" placeholder="充值密码"></el-input>
        </el-form-item>
        <el-form-item label="分配账号">
          <el-select v-model="form_operate.pasvUser" filterable allow-create default-first-option placeholder="请选择分配账号"
            style="width: 100%;" @change="handleChange">
            <el-option v-for="item in options" :key="item.id" :label="item.username" :value="item.username">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rechargeVisible = false">取 消</el-button>
        <el-button type="primary" @click="alarmNumUpdate">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { isAuth } from "@/utils";
export default {
  data() {
    return {
      emailThreshold: '',
      smsThreshold: '',
      voiceThreshold: '',
      emailBalanceList: [],
      smsBalanceList: [],
      voiceBalanceList: [],
      dialogFormVisible: false,
      operateVisible: false,
      rechargeVisible:false,
      form: {
        smsThreshold: '',
        emailThreshold: '',
        voiceThreshold: ''
      },
      form_operate: {
        type: '',
        balance: '',
        time: '',
        totalCount: '',
        userList: '',
        password: '',
        pasvUser: ''
      },
      options: [],
      formLabelWidth: '120px',
      alarmBalanceType: '',
      recordId: ''
    }
  },
  created() {
    this.getDataList();
    this.$http({
      url: this.$http.adornUrl('user/subordinate/list'),
      method: 'get',
    }).then(({ data }) => {
      if (data && data.code === 200) {
        this.options = data.data
      }
    })
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.$http({
        url: this.$http.adornUrl('alarmBalance/management'),
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.emailThreshold = data.data.emailThreshold
          this.smsThreshold = data.data.smsThreshold
          this.voiceThreshold = data.data.voiceThreshold
          this.emailBalanceList = data.data.emailBalanceList
          this.smsBalanceList = data.data.smsBalanceList
          this.voiceBalanceList = data.data.voiceBalanceList
        }
      })
    },
    operate(val, type) {
      this.operateVisible = true
      this.options = []
      this.form_operate.userList = ''
      this.form_operate.totalCount = ''
      this.alarmBalanceType = type
      this.recordId = val.id
      if (type == '0') {
        this.form_operate.type = '短信'
        this.form_operate.balance = val.smsBalance
        this.form_operate.time = val.smsEndTime
      } else if (type == '1') {
        this.form_operate.type = '语音'
        this.form_operate.balance = val.voiceBalance
        this.form_operate.time = val.voiceEndTime
      } else if (type == '2') {
        this.form_operate.type = '邮件'
        this.form_operate.balance = val.emailBalance
        this.form_operate.time = val.emailEndTime
      }
      this.$http({
        url: this.$http.adornUrl('user/subordinate/list'),
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.options = data.data
        }
      })
    },
    alarmBalanceUpdate() {
      this.$http({
        url: this.$http.adornUrl('alarmBalance/update'),
        method: 'post',
        data: this.$http.adornData({
          'smsThreshold': this.form.smsThreshold,
          'emailThreshold': this.form.emailThreshold,
          'voiceThreshold': this.form.voiceThreshold,
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.$message({
            message: data.msg,
            type: 'success',
            duration: 1000,
          })
          this.getDataList();
          this.dialogFormVisible = false;
        } else {
          this.$message.error(data.msg);
        }
      })
    },
    // 充值
    alarmNumUpdate(){
      this.$http({
        url: this.$http.adornUrl('recharge/alarmNum'),
        method: 'post',
        data: this.$http.adornData({
          'pasvUser': this.form_operate.pasvUser,
          'password': this.form_operate.password,
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.$message({
            message: data.msg,
            type: 'success',
            duration: 1000,
          })
          this.getDataList();
          this.rechargeVisible = false;
        } else {
          this.$message.error(data.msg);
        }
      })
    },
    handleChange(val) {
      this.form_operate.userList = val
    },
    allocation() {
      this.$http({
        url: this.$http.adornUrl('alarmBalance/allocation'),
        method: 'post',
        data: this.$http.adornData({
          'userList': this.form_operate.userList,
          'alarmBalanceType': this.alarmBalanceType,
          'recordId': this.recordId,
          'totalCount': this.form_operate.totalCount
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.$message({
            message: data.msg,
            type: 'success',
            duration: 1000,
          })
          this.getDataList();
          this.operateVisible = false;
        } else {
          this.$message.error(data.msg);
        }
      })
    },
    //权限
    isAuth(key) {
      return isAuth(key)
    },
  }
}
</script>
<style>
.tkye{
  height: 500px;
}
.mod-config {
  height: 100%;
}

.boxindex .item {
  margin-bottom: 18px;
}

.boxindex .clearfix:before,
.boxindex .clearfix:after {
  display: table;
  content: "";
}

.boxindex .clearfix:after {
  clear: both
}

.boxindex {
  display: flex;
  justify-content: space-around;
}

.boxindex .box-card {
  width: 31%;
  height: 500px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.4) !important;
}

.boxindex .clearfix {
  text-align: left;
}

.boxindex .clearfix .list_i {
  display: inline-block;
  width: 11px;
  height: 79px;
  background: #3894FF;
  float: left;
  border-radius: 10px;
}

.clearfix span:nth-child(2) {
  display: block;
  height: 40px;
  line-height: 40px;
  padding-left: 20px;
  font-size: 30px;
}

.clearfix span:nth-child(3) {
  height: 40px;
  line-height: 40px;
  border: 1px solid #1AAD19;
  border-radius: 10px;
  padding: 6px;
  margin-left: 10px;
  color: #1AAD19;
}

.clearfix span:nth-child(3) i {
  font-style: normal;
  padding-left: 20px;
}

.tk {
  margin-top: 15vh !important;
}

.tk .el-dialog__body {
  height: auto !important;
  overflow-y: auto !important
}

.boxindex .el-dropdown-menu__item {
  padding: 0;
}

.boxindex .el-form-item {
  margin-bottom: 6px !important
}
</style>


// WEBPACK FOOTER //
// src/pages/admincenter/management/index.vue